import ndsTokens from 'nicollet-tokens';

var linkColors = ndsTokens.colors.link; // Color getters

var getColorPair = function getColorPair(color) {
  return linkColors[color] || linkColors.onLight;
};

var getColor = function getColor(color) {
  return getColorPair(color).default;
};

var getHoverColor = function getHoverColor(color, noHoverColor) {
  return noHoverColor ? getColorPair(color).default : getColorPair(color).hover;
}; // Underline getters
// These take the underline policy prop as their only argument, and return the
// appropriate value of 'text-decoration'.


var getUnderline = function getUnderline(u) {
  return u === 'default' || u === 'always' ? 'underline' : 'none';
};

var getHoverUnderline = function getHoverUnderline(u) {
  return u === 'default' || u === 'never' ? 'none' : 'underline';
}; // CSS text emitting functions
// For use in Styled Component blocks


var defaultStyles = function defaultStyles(_ref) {
  var color = _ref.color,
      underline = _ref.underline;
  var colorValue = getColor(color);
  var underlineValue = getUnderline(underline);
  return "\n    vertical-align: baseline;\n    position: relative;\n    cursor: pointer;\n    color: ".concat(colorValue, ";\n    &:visited {\n      color: ").concat(colorValue, ";\n    }\n    text-decoration: ").concat(underlineValue, ";\n  ");
};
var hoverStyles = function hoverStyles(_ref2) {
  var color = _ref2.color,
      noHoverColor = _ref2.noHoverColor,
      underline = _ref2.underline;
  return "\n  &:hover {\n    color: ".concat(getHoverColor(color, noHoverColor), ";\n    text-decoration: ").concat(getHoverUnderline(underline), "\n  }\n");
};
var focusStyles = function focusStyles(_ref3) {
  var color = _ref3.color,
      noHoverColor = _ref3.noHoverColor;
  var hoverColorValue = getHoverColor(color, noHoverColor);
  return "\n    &:focus {\n      color: ".concat(hoverColorValue, "; /* Focus text color matches hover text color */\n      text-decoration: none;\n      outline-style: dashed;\n      outline-offset: 3px;\n      outline-width: 1px;\n      outline-color: ").concat(hoverColorValue, "; /* Outline matches hover text color */\n    }\n  ");
};

export { defaultStyles, hoverStyles, focusStyles };
